import { FC, memo } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { Nekuodah } from '~/common/components/Nekuodah';
import { queryClient } from '../../lib/reactQuery';
import { GlobalStyles } from '../GlobalStyles.component';
import { SEOHead } from '../SEOHead';
import { PROVIDER_STACK } from './constants/providerStack';
import { useAppProviders } from './hooks/useAppProviders';
import { AppProvidersProps } from './types/AppProvidersProps';

const AppProvidersComponent: FC<AppProvidersProps> = ({ children }) => {
  const { documentTitle, isReady } = useAppProviders();

  if (!isReady) return null;

  return (
    <QueryClientProvider client={queryClient}>
      <Nekuodah components={PROVIDER_STACK}>
        <GlobalStyles />
        <SEOHead title={documentTitle} />
        <ReactQueryDevtools initialIsOpen={false} />
        {children}
      </Nekuodah>
    </QueryClientProvider>
  );
};

export const AppProviders = memo(AppProvidersComponent);
